import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  const selectorRef = useRef(null);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'es', countryCode: 'CO', name: 'Español', flag: '🇨🇴' },
    { code: 'en', countryCode: 'US', name: 'English', flag: '🇺🇸' },
    { code: 'fr', countryCode: 'FR', name: 'Français', flag: '🇫🇷' },
    { code: 'it', countryCode: 'IT', name: 'Italiano', flag: '🇮🇹' }
  ];

  const currentLanguage = languages.find(lang => lang.code === language) || languages[0];

  const updateDropdownPosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 8,
        right: window.innerWidth - rect.right
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      updateDropdownPosition();
      document.addEventListener('mousedown', handleClickOutside);
      window.addEventListener('resize', updateDropdownPosition);
      window.addEventListener('scroll', updateDropdownPosition, true);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', updateDropdownPosition);
      window.removeEventListener('scroll', updateDropdownPosition, true);
    };
  }, [isOpen]);

  const handleToggle = () => {
    if (!isOpen) {
      updateDropdownPosition();
    }
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (langCode) => {
    setLanguage(langCode);
    setIsOpen(false);
  };

  const dropdownContent = isOpen && (
    <div
      className="language-dropdown"
      ref={dropdownRef}
      style={{
        top: `${dropdownPosition.top}px`,
        right: `${dropdownPosition.right}px`
      }}
    >
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          className={`language-option ${language === lang.code ? 'active' : ''}`}
          onClick={() => handleLanguageChange(lang.code)}
        >
          <span className="language-flag">{lang.flag}</span>
          <span className="language-name">{lang.name}</span>
        </button>
      ))}
    </div>
  );

  return (
    <div className="language-selector" ref={selectorRef}>
      <button
        ref={buttonRef}
        type="button"
        className="language-button"
        onClick={handleToggle}
        aria-label="Seleccionar idioma"
        aria-expanded={isOpen}
      >
        <span className="language-flag">{currentLanguage.flag}</span>
        <span className="language-name">{currentLanguage.name}</span>
        <span className="language-arrow">▼</span>
      </button>
      {ReactDOM.createPortal(dropdownContent, document.body)}
    </div>
  );
};

export default LanguageSelector;


